export default class SuepService {

  static allowInfoAfterDischarge: boolean;
  static isDeceased: boolean;

  static clean(): void {
    this.allowInfoAfterDischarge = true;
    this.isDeceased              = false;
  }

  static allowInfo(): boolean {
    return this.allowInfoAfterDischarge && !this.isDeceased;
  }
}
